import React from 'react';

export default () => <span> •&nbsp;</span>;
